/**
 * @fileoverview added by tsickle
 * Generated from: util/string-utils.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var CAMEL_CASE_REGEX = /([0-9a-z])([A-Z])/g;
/** @type {?} */
var CAMEL_CASE_NUM_REGEX = /([a-z])([0-9]+)$/;
/**
 * @param {?} str
 * @return {?}
 */
export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * @param {?} str
 * @param {?=} __1
 * @return {?}
 */
export function camelCase(str, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.delimiter, delimiter = _c === void 0 ? '_' : _c;
    /** @type {?} */
    var re = new RegExp(delimiter + "(\\w)", 'g');
    return str.replace(re, (/**
     * @param {?} match
     * @param {?} p1
     * @return {?}
     */
    function (match, p1) { return p1.toUpperCase(); }));
}
/**
 * @param {?} match
 * @param {?} p1
 * @param {?} p2
 * @return {?}
 */
function camelCaseReplace(match, p1, p2) {
    return p1 + "_" + p2.toLowerCase();
}
/**
 * @param {?} camelCaseStr
 * @return {?}
 */
export function underscoreDelimit(camelCaseStr) {
    return camelCaseStr.replace(CAMEL_CASE_REGEX, camelCaseReplace).replace(CAMEL_CASE_NUM_REGEX, camelCaseReplace);
}
